import { authorizedFetchRaw } from './authorizedFetch';

export const collectPagedResource = (
  baseUrl: Promise<string> | string,
): (<T>(path: string, pageSize?: number | undefined) => Promise<T[]>) => {
  const fetch = authorizedFetchRaw(baseUrl);

  return async <T>(path: string, pageSize?: number): Promise<T[]> => {
    const results: T[] = [];
    let response;
    let nextUrl: string = path;
    let pathWithQueryParams = '';
    do {
      if (nextUrl === path && pageSize) {
        const defaultPaging = `page=1&size=${pageSize}`;
        pathWithQueryParams = path.includes('?') ? `${path}&${defaultPaging}` : `${path}?${defaultPaging}`;
      }
      response = await fetch(pathWithQueryParams || nextUrl, { method: 'GET' });

      const contentType = response.headers.get('Content-type');
      if (contentType && contentType.includes('application/json')) {
        results.push(...(await response.json()));
      }

      nextUrl = response.headers.get('x-next');
      pathWithQueryParams = '';
    } while (nextUrl);
    return results;
  };
};
